import React from 'react'
import { Button } from '../ui'

/**
 * Component for displaying a list of calendar connections with action buttons
 */
const ConnectionList = ({
  title,
  connections,
  userField,
  allowActions,
  onAccept,
  onReject,
  onDelete,
  emptyMessage,
}) => {
  // Helper function to get the user data from each connection based on the userField param
  const getUserData = (connection) => {
    const field =
      typeof userField === 'function' ? userField(connection) : userField

    return connection[field]
  }

  // Format date to be more readable
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  return (
    <div className="mt-8">
      <h3 className="text-lg font-medium">{title}</h3>

      {connections.length === 0 ? (
        <p className="text-gray-500 text-sm">{emptyMessage}</p>
      ) : (
        <ul className="divide-y divide-gray-200">
          {connections.map((connection) => {
            const userData = getUserData(connection)

            return (
              <li key={connection.id} className="py-3">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-medium">
                      {userData?.first_name} {userData?.last_name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {userData?.email}
                    </div>
                    <div className="text-xs text-gray-400">
                      {connection.status === 'pending'
                        ? `Requested on ${formatDate(connection.created_at)}`
                        : `Connected since ${formatDate(connection.updated_at)}`}
                    </div>
                  </div>

                  <div className="flex gap-2">
                    {allowActions && connection.status === 'pending' && (
                      <>
                        <Button
                          variant="success"
                          className="text-xs px-2 py-1"
                          onClick={() => onAccept(connection.id)}
                        >
                          Accept
                        </Button>
                        <Button
                          variant="danger"
                          className="text-xs px-2 py-1"
                          onClick={() => onReject(connection.id)}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                    {onDelete && (
                      <Button
                        variant="secondary"
                        className="text-xs px-2 py-1"
                        onClick={() => onDelete(connection.id)}
                      >
                        {connection.status === 'pending'
                          ? 'Cancel'
                          : 'Disconnect'}
                      </Button>
                    )}
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default ConnectionList
